/**
 * Where the frontend looks for the API.
 *
 * Everything goes through here — the enquiry forms, the newsletter signup, the
 * internship application, the visitor tracker and the admin console all import
 * this value, so it is the single place that decides which server they talk to.
 *
 * Set REACT_APP_API_URL to override. Create React App inlines it at BUILD time,
 * so it must be present when you run `npm run build`, not when the server
 * starts.
 *
 *   .env.development.local   REACT_APP_API_URL=http://localhost:9001
 *   .env.production          REACT_APP_API_URL=https://api.starparth.com
 *
 * With no override the defaults below are sensible on their own:
 *
 *   development  http://localhost:9001, the port the API listens on.
 *
 *   production   empty, which makes every request same-origin — /api/contacts
 *                resolves against whatever domain served the page. That is what
 *                deploy/nginx.conf sets up: it proxies /api/ through to the
 *                backend on port 9001. Same-origin also means no CORS preflight
 *                and no cross-site cookie rules to fight.
 */
const OVERRIDE = process.env.REACT_APP_API_URL?.replace(/\/+$/, '');

const DEFAULT =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:9001'
    : ''; // same origin; nginx proxies /api/ to the backend

const BASE_URL = OVERRIDE || DEFAULT;

if (process.env.NODE_ENV === 'development' && !OVERRIDE) {
  console.info(`[config] API base URL: ${BASE_URL} (set REACT_APP_API_URL to change it)`);
}

export default BASE_URL;
